import { Button } from "@/components/ui/button";
import { STATUS } from "@/config/progress";
import { KEYS } from "@/lib/tourHelper";
import { Status } from "@/schema/app/assessment/status";
import { Document } from "@/schema/app/document";
import { DocumentArrowUpRegular } from "@fluentui/react-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DocumentTable from "./DocumentTable";
import DocumentUploadDialog from "./DocumentUploadDialog";
import EmptyList from "./EmptyList";

interface DocumentListProps {
  status: Status;
  data: Document[];
}

function DocumentList({ status, data }: DocumentListProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div>
      {/* heading */}
      {/* <DocumentUploadDialog open={open} setOpen={setOpen} />
      <div className="mb-4 flex items-start justify-between gap-8">
        <div className="grow flex-col gap-2">
          <div className="text-lg font-bold">{t("document-upload-title")}</div>
          <div>{t("document-limit-message1")}</div>
          <div>{t("document-limit-message2")}</div>
          <div>{t("document-limit-message3")}</div>
        </div>
        <div>
          {data.length < 5 && status.id < STATUS.SUBMITTED && (
            <Button
              data-tour={KEYS.ASSESSMENT.UPLOAD_BUTTON}
              variant="outline"
              onClick={() => setOpen(true)}
            >
              <DocumentArrowUpRegular className="mr-2" />
              {t("upload-document")}
            </Button>
          )}
        </div>
      </div>
      <div data-tour={KEYS.ASSESSMENT.DOCUMENT_LIST}>
        {data.length === 0 ? <EmptyList /> : <DocumentTable data={data} />}
      </div> */}
    </div>
  );
}

export default DocumentList;
